import { render } from "./TeacherTest.vue?vue&type=template&id=35ad1db0"
import script from "./TeacherTest.vue?vue&type=script&lang=js"
export * from "./TeacherTest.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__